(() => {
  if (customElements.get('pc-product-modifications')) return;
  customElements.define('pc-product-modifications', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const input = this.querySelector('[data-modifications-input]');
      const property = this.querySelector('[data-modifications-property]');
      const sync = () => {
        property.value = input.value.trim();
        property.disabled = property.value === '';
      };
      input.addEventListener('input', sync);
      input.addEventListener('change', sync);
      sync();
    }
  });
})();
